import avo from 'analytics/avo';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePdpSelectedOptionsVariantSku from 'components/consumer/PDP/state/pdpSelectedOptionsVariantSku/usePdpSelectedOptionsVariantSku';
import { getGTMAddToCartData, getHeapAddToCartData } from './useUserCartEvent';
import usePDPContext from '../../components/consumer/PDP/state/context/usePDPContext';

const useAddToWishList = (basicDetails, optionData, priceData, isClearance) => {
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const selectedOptionsVariantSku = usePdpSelectedOptionsVariantSku();
  const variantSkuFlashSale = !!usePDPContext()?.productOptions?.data?.stock
    ?.variantSkuFlashSale?.[selectedOptionsVariantSku];

  const getAddToWishListEventData = () => {
    const eventData = getGTMAddToCartData({
      isClearance,
      isDecideLater: pdpSelectedCustomizerTab === 'decide-later',
      isFavorited: true,
      isQuickShip: optionData?.stock?.isSelectedOptionsQuickship,
      optionPrice: priceData?.optionPrice,
      options: optionData.options,
      price: priceData?.price,
      product: basicDetails,
      selectedOptions: optionData.selectedOptions,
      sku: selectedOptionsVariantSku,
    });

    const heapData = getHeapAddToCartData(basicDetails, eventData);
    delete heapData.favorited;
    delete heapData.quantity;

    const optionNames = optionData?.options
      ? Object.keys(optionData.selectedOptions)
          .map(
            optionTypeId =>
              optionData.selectedOptionsExtended[optionTypeId].value.value
          )
          .join(', ')
      : null;

    const avoData = {
      productId: basicDetails.id,
      fabricId: eventData.fabric_id,
      fabricName: eventData.fabric_name,
      price: parseFloat(eventData.price),
      productFamily: eventData?.product_family || '',
      sku: eventData.sku,
      fabricColor: eventData.fabric_color,
      fullPrice: parseFloat(eventData.full_price),
      isClearance,
      quickship: eventData.quickship,
      location: avo.Location.PDP,
      name: eventData.product_name,
      variant: optionNames,
      category: eventData.product_type,
      currency: 'USD',
    };
    return { heapData, avoData };
  };

  const addToWishListEvent = () => {
    const data = getAddToWishListEventData();
    avo.productAddedToWishlist(data.avoData);
  };

  const removeFromWishListEvent = () => {
    const { avoData } = getAddToWishListEventData();
    avo.productRemovedFromWishlist({
      productId: avoData.productId,
      category: avoData.category,
      isClearance: avoData.isClearance,
      name: avoData.name,
      price: parseFloat(avoData.price),
      quantity: 1,
      sku: avoData.sku,
      variant: avoData.variant,
      fullPrice: parseFloat(avoData.fullPrice),
      productFamily: avoData?.productFamily || '',
      contentIds: avoData.sku.split('-').slice(0, 1),
      currency: avoData?.currency,
      isFlashSale: variantSkuFlashSale,
    });
  };

  return {
    addToWishListEvent,
    getAddToWishListEventData,
    removeFromWishListEvent,
  };
};

export default useAddToWishList;
